module.exports = __webpack_public_path__ + "static/media/baner_assigned_training.284fffbc.jpg";